import React from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Icon } from "@mui/material";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const PRIMARY_COLOR = "#0070C2";

const StyledCard = styled(Card)(({ theme }) => ({
  cursor: "pointer",
  transition: "all 0.3s ease-in-out",
  "&:active": {
    transform: "translateY(0)",
  },
}));

function CustomCard({ icon: IconComponent, title, path, progessMessage, compact = false, reportCard = false }) {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (path) {
      navigate(`/${path}`);
    } else if (progessMessage) {
      toast.loading(progessMessage);
    }
  };
  const { t } = useTranslation();
  return (
    <StyledCard
      onClick={handleClick}
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        textAlign: "left",
        backgroundColor: `${PRIMARY_COLOR}08`,
        border: `1px solid ${PRIMARY_COLOR}`,
        borderRadius: "8px",
        padding: compact ? "6px 8px" : "10px",
        gap: compact ? "8px" : "16px",
        height: compact ? "62px" : "100%",
        minHeight: compact ? "62px" : "80px",
        ...(reportCard && {
          backgroundColor: "#ffffff",
          borderColor: "#dbe4ef",
          boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
          "&:hover": {
            borderColor: PRIMARY_COLOR,
            boxShadow: "0 5px 14px rgba(0, 112, 194, 0.12)",
            transform: "translateY(-1px)",
          },
          "&:focus-visible": {
            outline: `2px solid ${PRIMARY_COLOR}`,
            outlineOffset: "2px",
          },
        }),
      }}
    >
      <Icon
        sx={{
          color: PRIMARY_COLOR,
          fontSize: compact ? (reportCard ? "1.45rem" : "1.6rem") : "2.5rem",
          width: compact ? (reportCard ? "1.45rem" : "1.6rem") : "2.5rem",
          height: compact ? (reportCard ? "1.45rem" : "1.6rem") : "2.5rem",
          ...(reportCard && {
            padding: "5px",
            boxSizing: "content-box",
            borderRadius: "6px",
            backgroundColor: `${PRIMARY_COLOR}10`,
          }),
          flexShrink: 0,
          transition: "transform 0.3s ease",
          ".MuiCard-root:hover &": {
            transform: "scale(1.1)",
          },
        }}
        className="!flex items-center justify-center"
      >
        <IconComponent style={{ width: "100%", height: "100%" }} />
      </Icon>
      <CardContent sx={{ padding: "0 !important" }}>
        <Typography
          component="div"
          sx={{
            fontWeight: 600,
            fontSize: compact ? (reportCard ? "0.88rem" : "0.95rem") : undefined,
            color: "text.primary",
            transition: "color 0.3s ease",
            ".MuiCard-root:hover &": {
              color: PRIMARY_COLOR,
            },
          }}
        >
          {t(title)}
        </Typography>
        {!reportCard && (
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mt: 0.5,
              opacity: 0.8,
              fontSize: compact ? "0.75rem" : "0.875rem",
            }}
          >
            {t("Click to explore")}
          </Typography>
        )}
      </CardContent>
    </StyledCard>
  );
}

export default CustomCard;
